export default {
  classPrefix: 't',
  form: {
    requiredMark: undefined,
  },
} as const;
